var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfigurePolicies(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 35.2737V42C43 44.2091 41.2091 46 39 46H10C7.79086 46 6 44.2091 6 42V9.41421C6 9.149 6.10536 8.89464 6.29289 8.70711L12.7071 2.29289C12.8946 2.10536 13.149 2 13.4142 2H39C41.2091 2 43 3.79086 43 6V30.1789M7 9.5H12C12.5523 9.5 13 9.05228 13 8.5V3",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 9H42.5",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 27H28",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32H19",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 27,
    height: 6,
    rx: 1,
    fill: "#E9F0FF",
    stroke: "#256BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 43C30.4682 43 28 40.5318 28 37.5C28 34.4682 30.4682 32 33.5 32C36.5318 32 39 34.4682 39 37.5C39 40.5318 36.5318 43 33.5 43Z",
    fill: "#E9F0FF",
    stroke: "#256BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0631 39C32.9286 39 32.7942 38.9555 32.6916 38.8666L31.1539 37.5343C30.9487 37.3565 30.9487 37.0682 31.1539 36.8903C31.3592 36.7126 31.6917 36.7126 31.897 36.8903L33.0632 37.9007L35.103 36.1333C35.3082 35.9556 35.6408 35.9556 35.8461 36.1333C36.0513 36.3111 36.0513 36.5994 35.8461 36.7772L33.4347 38.8667C33.3321 38.9555 33.1976 39 33.0631 39Z",
    fill: "#256BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurePolicies);
export default __webpack_public_path__ + "static/media/configure_policies.94f9d79804c56ba96b3d6b3effd43c69.svg";
export { ForwardRef as ReactComponent };